export const CALCULATOR_THANK_YOU_PAGE = 'https://bodil.energy/din-rapport-er-pa-vej/';
export const CALCULATOR_THANK_YOU_PAGE_NORLYS = 'https://partner.norlys.dk/BodilEnergi/';

export const CREATE_OFFER_ERROR_MESSAGE = `Der skete desværre en fejl, og Deres tilbud kunne ikke oprettes.\n\nPrøv igen, eller kontakt os direkte på mail eller telefon.\n\nVi beklager ulejligheden.`;

export const BODIL_ENERGI = 'https://bodil.energy';
export const BODIL_PRIVACY_POLICY_URL = 'https://bodil.energy/privatlivspolitik';

// Booking destinations. NO TRAILING SLASHES — that is not a style preference.
// This constant used to read '…/book-et-kald/' and returned a hard 404: the page
// was retired and redirected to /kontakt, but the redirect rule only matches the
// slashless form. '/book-et-kald' 301s correctly, '/book-et-kald/' does not, so
// the one character was the whole bug a Jyske Bank contact reported. Pointing
// straight at the destination rather than leaning on a redirect.
export const BODIL_BOOK_URL = 'https://bodil.energy/kontakt';
export const EDC_BOOK_URL = 'https://bodil.energy/edc-energiradgivning-booking';
export const NORLYS_BOOK_URL = 'https://bodil.energy/norlys-booking';
export const JYSKE_BANK_BOOK_URL = 'https://bodil.energy/jyske-bank-energiradgivning-booking';
export const NORDEA_BOOK_URL = 'https://bodil.energy/nordea-booking';

/**
 * Where "Book tid" should send a visitor, given the lead origin of the page.
 *
 * Single source of truth on purpose. There used to be two: this mapping lived
 * inside useNavigateToAdvisorBooking (the estimate-page CTA) and knew every
 * partner, while the calculator header did its own `origin === 'edc' ? … : …` and
 * knew only EDC. So on /jyskebank and /nordea the header sent people to the
 * generic Bodil link instead of the partner's own booking page — which is what
 * the customer hit.
 */
export const getBookingURLByLeadOrigin = (leadOrigin?: string): string => {
  switch (leadOrigin) {
    case 'jyskebank':
      return JYSKE_BANK_BOOK_URL;
    case 'nordea':
      return NORDEA_BOOK_URL;
    case 'norlys':
      return NORLYS_BOOK_URL;
    case 'edc':
      return EDC_BOOK_URL;
    default:
      return BODIL_BOOK_URL;
  }
};

export const BODIL_EMAIL = 'hej@bodil.energy';
export const BODIL_PHONE_NUMBER = '+ 45 71 74 18 41';
export const BODIL_ADDRESS = 'Frederiksborggade 22, 1360 København K';
export const BODIL_CVR = '41246421';
export const BODIL_COPYRIGHT = '©2024 Bodil Energi';
